<template>
  <section class="test-panel" aria-label="Konu testi">
    <template v-if="BookTests && BookTests.length">
      <template v-if="isShowResult">
        <header class="test-heading"><div><span class="test-eyebrow">TEST SONUCU</span><h2>Test tamamlandı</h2></div><span class="test-count">{{ BookTests.length }} soru</span></header>
        <div class="result-summary" aria-live="polite">
          <div class="result-stat correct"><i class="bi bi-check-circle" aria-hidden="true"></i><div><strong>{{ totalCorrect }}</strong><span>Doğru cevap</span></div></div>
          <div class="result-stat incorrect"><i class="bi bi-x-circle" aria-hidden="true"></i><div><strong>{{ totalInCorrect }}</strong><span>Yanlış cevap</span></div></div>
        </div>
        <p class="test-hint">Cevaplarını ve doğru seçenekleri aşağıda inceleyebilirsin.</p>
        <article v-for="(q, index) in BookTests" :key="q.id" class="review-card">
          <span class="test-count">Soru {{ index + 1 }}</span>
          <div class="question-text" v-html="q.question"></div>
          <div class="test-options">
            <div v-for="(option, optionIndex) in options(q)" :key="optionIndex" class="test-option" :class="OptionColor(optionIndex, q)">
              <span class="option-letter">{{ letters[optionIndex] }}</span>
              <div class="option-body"><div v-html="option"></div><small v-if="optionStatus(optionIndex, q)">{{ optionStatus(optionIndex, q) }}</small></div>
            </div>
          </div>
        </article>
      </template>
      <template v-else>
        <header class="test-heading"><div><span class="test-eyebrow">KONU TESTİ</span><h2>Bilgini kontrol et</h2></div><span class="test-count">Soru {{ progressNumber }} / {{ BookTests.length }}</span></header>
        <div class="test-progress" role="progressbar" aria-label="Test ilerlemesi" :aria-valuenow="progressNumber" aria-valuemin="0" :aria-valuemax="BookTests.length"><div :style="{width: progressWith + '%'}"></div></div>
        <p class="test-hint">Bir cevap seçtiğinde sonraki soruya geçilir.</p>
        <div v-if="question" :key="questionNumber" class="question-card">
          <div class="question-text" v-html="question.title"></div>
          <div class="test-options" role="group" :aria-label="'Soru ' + progressNumber + ' cevapları'">
            <button v-for="(option, index) in options(question)" :key="index" type="button" class="test-option" @click="NextQuestion(index)">
              <span class="option-letter">{{ letters[index] }}</span><div class="option-body" v-html="option"></div>
            </button>
          </div>
        </div>
      </template>
    </template>
    <div v-else class="test-empty" role="status"><i class="bi bi-journal-check" aria-hidden="true"></i><p>Bu konunun testleri hazırlanıyor.</p></div>
  </section>
</template>
<script>
import {mapActions } from "vuex";
import {DateFormat} from '@/common/datetime-helper';
export default {
    name: "TabTestSubject",
    props: {
      //[{"id":1,"sequence": 1,"question": "How are you today?","optionA": "You’re fine","optionB": "I’m fine","optionC": "I’m 32","optionD": "I’m Turkish"}]
      BookTests:{
        type:Array,
      },
      BookId:{
        type:String,
        default:null
      }
    },
    
    data() {
        return {
            letters: ['A', 'B', 'C', 'D'],
            questionNumber:0,
            userAnswers:[],
            beginTime:DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true),
            finishTime:'',
            isShowResult:false,
            
            totalDuration:'00:00:00',
            totalInCorrect:0,
            totalCorrect:0,
        }
    },
    computed: {
        progressNumber() {
            if(this.BookTests && this.BookTests.length>0){
            let questionCount = this.BookTests.length;
            if (this.questionNumber <= 0) {
                return 1;
            }
            else if ((questionCount - 1) <= this.questionNumber) {
                return questionCount;
            }
            else {
                return (this.questionNumber + 1);
            }
            }
            return 1;
        },
        progressWith: function () {
            if(this.BookTests && this.BookTests.length>0){
            return ((this.progressNumber * 100) / this.BookTests.length).toFixed(1);
            }
            return 0;
        },
        question(){
            let result = null
            if(this.BookTests && this.BookTests.length>0){
                if(this.questionNumber>=0 && this.questionNumber<this.BookTests.length){
                    let data = this.BookTests[this.questionNumber];
                    result = {
                        title : data.question,
                        optionA : data.optionA,
                        optionB : data.optionB,
                        optionC : data.optionC,
                        optionD : data.optionD
                    };
                }
            }
            return result;
        },
    },
    methods: {
        ...mapActions(["SaveAnswerBookTest"]),
        options(question) { return [question.optionA, question.optionB, question.optionC, question.optionD]; },
        optionStatus(index, question) {
            const selected = this.userAnswers.find(answer => answer.Id === question.id)?.Answer;
            if (Number(question.right) === index) return Number(selected) === index ? 'Doğru cevabın' : 'Doğru cevap';
            return Number(selected) === index ? 'Senin cevabın' : '';
        },
        NextQuestion(value=0){
            if (this.isShowResult || !this.BookTests?.length) return;
            if (this.questionNumber >= 0 && this.questionNumber < this.BookTests.length) {
                let data = this.BookTests[this.questionNumber];
                this.userAnswers.push({ Id: data.id, Answer: value });
            }
            this.questionNumber++;
            if (this.questionNumber >= this.BookTests.length) {
                this.finishTime=DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true);
                this.SaveAnswer({
                    bookId:this.BookId,
                    beginDate:this.beginTime,
                    finishDate:this.finishTime,
                    answerContent:JSON.stringify(this.userAnswers)
                });
                this.QuestionControl();
                this.isShowResult=true;
            }
        },
        async SaveAnswer(form){    
            await this.SaveAnswerBookTest(form)
            .then(()=>{})
            .catch(()=>{});
        },
        OptionColor(optionIndex,question) {
            if(!this.userAnswers || this.userAnswers.length==0) return;

            let id = question.id;
            let right = question.right;
            let answer = this.userAnswers.find(x=>x.Id===id).Answer;
            
            let classStr = '';
            if ((parseInt(optionIndex,10) === parseInt(answer,10) && parseInt(answer,10) === parseInt(right,10)) || (parseInt(right,10) === parseInt(optionIndex,10))){
                classStr = 'option-correct';
            }
            else if (parseInt(optionIndex,10) === parseInt(answer,10)){
                classStr = 'option-incorrect';
            }
            else{
                classStr = '';
            }
            return classStr;
            
        },
        QuestionControl(){
            this.totalCorrect = 0;
            this.totalInCorrect = 0;
            for (let i = 0; i < this.BookTests.length; i++) {
                let data = this.BookTests[i];
                let answer = this.userAnswers.find(x=>x.Id===data.id).Answer;  
                if(data.right===answer){
                    this.totalCorrect++;
                }else{
                    this.totalInCorrect++;
                }
            }
        },
    },
    watch: {
        Tests:function(){
        this.questionNumber=0;
        this.beginTime=DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true);
        this.finishTime='';
      }
    },
};
</script>
    
<style scoped>
.test-panel { color: #334155; }
.test-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 20px; }
.test-eyebrow { font-size: 11px; font-weight: 600; letter-spacing: .1em; color: #738174; }
h2 { font-size: 22px; color: #20382d; margin: 6px 0 0; }
.test-count { display: inline-block; background: #f1f5f9; color: #526174; padding: 7px 12px; border-radius: 9px; font-size: 13px; font-weight: 600; }
.test-progress { height: 6px; background: #edf2f6; border-radius: 6px; overflow: hidden; }
.test-progress > div { height: 100%; background: var(--brand-primary); }
.test-hint { margin: 14px 0 24px; color: #64748b; font-size: 14px; line-height: 1.6; }
.question-card, .review-card { border: 1px solid #e2e8f0; border-radius: 14px; padding: 24px; background: #fff; }
.review-card { margin-top: 20px; }
.question-text { margin: 18px 0 24px; font-size: 19px; line-height: 1.75; overflow-wrap: anywhere; color: #20382d; }
.question-text :deep(p:last-child), .option-body :deep(p:last-child) { margin-bottom: 0; }
.question-text :deep(img), .option-body :deep(img) { max-width: 100%; height: auto; }
.test-options { display: grid; gap: 12px; }
.test-option { display: flex; align-items: flex-start; gap: 14px; width: 100%; padding: 16px; text-align: left; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; color: #334155; font-size: 16px; line-height: 1.6; }
@media (hover: hover) and (pointer: fine) {
  button.test-option:hover { background: #f0fdf7; border-color: #86cdb1; }
}
button.test-option:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 3px; }
.option-letter { display: flex; align-items: center; justify-content: center; flex: 0 0 30px; height: 30px; background: #f1f5f9; border-radius: 8px; font-size: 14px; font-weight: 700; }
.option-body { min-width: 0; overflow-wrap: anywhere; }
.option-body small { display: block; font-weight: 600; margin-top: 6px; }
.option-correct { border-color: #a7dfc5; background: #ecfdf5; color: #166344; }
.option-incorrect { border-color: #fecaca; background: #fff1f2; color: #9f303b; }
.result-summary { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.result-stat { display: flex; align-items: center; gap: 16px; padding: 20px; border-radius: 14px; }
.result-stat.correct { background: #ecfdf5; color: #166344; }
.result-stat.incorrect { background: #fff1f2; color: #9f303b; }
.result-stat i { font-size: 26px; }
.result-stat strong { display: block; font-size: 30px; line-height: 1.2; }
.result-stat span { display: block; margin-top: 6px; font-size: 14px; }
.test-empty { text-align: center; padding: 40px 16px; color: #64748b; }
.test-empty i { display: block; font-size: 30px; margin-bottom: 12px; }
@media(max-width: 575px) { .question-card, .review-card { padding: 16px; } .question-text { font-size: 17px; } .test-option { padding: 12px; } .result-summary { gap: 10px; } .result-stat { padding: 14px; gap: 8px; } }
</style>
